import { IBulkTripsErrorType } from './bulk-trips-error-type.interface';
import { ITripOutputDto } from './trip-output-dto.interface';

export interface IBulkCreateOrUpdateTripsOutputDto {
    createdTrips: ITripOutputDto[];
    updatedTrips: ITripOutputDto[];
    errors: IBulkTripsErrorType[];
}
